/** Musical constants and the arrangement gate that gives a demo record a shape. */

const A4 = 440;

/** MIDI note number to frequency. */
export const mtof = (m: number): number => A4 * 2 ** ((m - 69) / 12);

/** Sixteenth notes. */
export const STEP_DIV = 4;
export const STEPS_PER_BAR = 16;
/** Seconds of audio scheduled ahead of the clock. */
export const LOOKAHEAD = 0.28;
/** Scheduler interval, milliseconds. */
export const TICK = 25;

export interface Layers {
  drums: boolean;
  hats: boolean;
  bass: boolean;
  arp: boolean;
  ride: boolean;
}

/**
 * Which layers are audible in a given bar. A 32-bar cycle with a four-bar
 * breakdown is what stops the generated music sounding like a loop.
 */
export function layers(bar: number): Layers {
  const c = bar % 32;
  const breakdown = c >= 16 && c < 20;
  return {
    drums: bar >= 2 && !breakdown,
    hats: bar >= 1 && !(c >= 16 && c < 18),
    bass: bar >= 4 && !breakdown,
    arp: (bar >= 8 && !breakdown) || c >= 20,
    ride: c >= 24,
  };
}

/** Seconds per sixteenth note at a tempo. */
export const stepDuration = (bpm: number): number => 60 / bpm / STEP_DIV;
